import React, { useEffect, useState } from 'react'
import InputField from '../../../feature-module/components/Input'
import { useForm } from 'react-hook-form'
import { ErrorToaster, SuccessToaster } from '../../../feature-module/components/toaster/Toaster'
import DeliveryTimeSlotServices from '../../../services/DeliveryTimeSlot'
import { modalCloseListener } from '../../../utils/helper'

const DeliveryTimeSlotForm = ({ updateData, resetUpdateData, getData }) => {

  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const submitForm = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        name: formData?.name,
        remarks: formData?.remarks,
        is_active: formData?.status
      }
      if (updateData?.id) {
        // *Update 
        await DeliveryTimeSlotServices.updateDeliveryTimeSlot(updateData?.id, obj)
        SuccessToaster('Update Successfully')
      } else {
        // *Create 
        await DeliveryTimeSlotServices.createDeliveryTimeSlot(obj)
        SuccessToaster('Create Successfully')
      }
      reset();
      const btn = document.getElementById('modalClose')
      btn.click();
      getData();
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (updateData) {
      setValue('name', updateData?.name)
      setValue('remarks', updateData?.remarks)
      setValue('status', updateData?.is_active)
    }
  }, [updateData]);

  useEffect(() => {
    const cleanup = modalCloseListener("open-modal", () => {
      reset();
      resetUpdateData();
    });

    return cleanup;
  }, []);

  return (
    <div className="modal fade" id="open-modal">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{updateData?.id ? "Update Delivery Time Slot" : "Create Delivery Time Slot"}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body new-employee-field">
                <form onSubmit={handleSubmit(submitForm)}>
                  <div className="mb-3">
                    <InputField
                      label="Time"
                      type="text"
                      error={errors?.name?.message}
                      register={register("name", {
                        required: 'Please enter time slot.',
                      })}
                    />
                  </div>
                  <div className="mb-3">
                    <InputField
                      label="Remarks"
                      inputType="textarea"
                      placeholder="Type Remarks"
                      register={register("remarks")}
                    />
                  </div>
                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label">Status</span>
                      <InputField
                        id="checkbox1"
                        type="checkbox"
                        className="check"
                        defaultChecked={true}
                        register={register("status")}
                      />
                    </div>
                  </div>
                  <div className="modal-footer-btn">
                    <button
                      id="modalClose"
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliveryTimeSlotForm
